/* Accessible Learn tabs with URL syncing and Shopify Theme Editor support. */
(function () {
  function initTabs(root) {
    if (root.dataset.lvLearnReady === 'true') return;
    root.dataset.lvLearnReady = 'true';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-lv-learn-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-lv-learn-panel]'));

    function activate(id, options) {
      options = options || {};
      var activeTab;
      root.setAttribute('data-lv-active', id);
      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-lv-learn-tab') === id;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        if (active) activeTab = tab;
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-lv-learn-panel') !== id;
      });
      if (options.focus && activeTab) activeTab.focus();
      if (options.updateUrl && !window.Shopify?.designMode && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('mode', id);
        history.replaceState(null, '', url.toString());
      }
    }

    root.lvActivateLearnTab = activate;
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-lv-learn-tab'), { updateUrl: true });
      });
      tab.addEventListener('keydown', function (event) {
        var nextIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        activate(tabs[nextIndex].getAttribute('data-lv-learn-tab'), { updateUrl: true, focus: true });
      });
    });

    var requested = new URLSearchParams(window.location.search).get('mode');
    var validRequested = panels.some(function (panel) {
      return panel.getAttribute('data-lv-learn-panel') === requested;
    });
    activate(validRequested ? requested : root.getAttribute('data-lv-active'), {});
  }

  function init(scope) {
    if (scope.matches && scope.matches('[data-lv-learn-tabs]')) initTabs(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-lv-learn-tabs]').forEach(initTabs);
  }
  function start() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-lv-goto-mode]');
    if (!trigger) return;
    var targetSelector = trigger.getAttribute('data-lv-tabs-target');
    var root = targetSelector ? document.querySelector(targetSelector) : document.querySelector('[data-lv-learn-tabs]');
    if (!root || !root.lvActivateLearnTab) return;
    event.preventDefault();
    root.lvActivateLearnTab(trigger.getAttribute('data-lv-goto-mode'), { updateUrl: true });
    root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
})();
